import { toArray, defaultArg, map } from "../fable_modules/fable-library.3.7.12/Option.js";
import { isNullOrWhiteSpace, split } from "../fable_modules/fable-library.3.7.12/String.js";
import { iterate, empty as empty_1, singleton as singleton_1, append, map as map_1, delay, toList } from "../fable_modules/fable-library.3.7.12/Seq.js";
import * as react from "react";
import { Option, columns } from "../fable_modules/Fulma.2.16.0/Layouts/Columns.fs.js";
import { ofArray, empty, singleton } from "../fable_modules/fable-library.3.7.12/List.js";
import { Option as Option_1, ISize, column } from "../fable_modules/Fulma.2.16.0/Layouts/Column.fs.js";
import { Color_IColor, FlexJustifyContent_Option, FlexGrow_Option, FlexDirection_Option, Modifier_IModifier, Common_GenericOption, Screen } from "../fable_modules/Fulma.2.16.0/Common.fs.js";
import { footer, content, Header_title, header, card } from "../fable_modules/Fulma.2.16.0/Components/Card.fs.js";
import { FormField_labeledField } from "../Optiscan.SharedUI/Forms.js";
import { End_div, Item_Option, Item_div, Start_div, Option as Option_2, navbar } from "../fable_modules/Fulma.2.16.0/Components/Navbar.fs.js";
import { Option as Option_3, label } from "../fable_modules/Fulma.2.16.0/Elements/Form/Label.fs.js";
import { HTMLAttr } from "../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { ControlMessage_tryFromRaw_4A75406F, ILiveTelepathologyProps } from "./TelepathologyBindings.js";
import { TelepathologyMsg } from "./TelepathologyTypes.js";
import { keyValueList } from "../fable_modules/fable-library.3.7.12/MapUtil.js";
import LiveTelepathology from "../../../src/Optiscan.Client/TelepathologyCommon/js/LiveTelepathology.tsx";
import { Helpers_nothing } from "../fable_modules/Fable.React.7.4.3/Fable.React.Helpers.fs.js";
import { Card_foot, Card_body, Card_head, Card_card, background, Option as Option_4, modal } from "../fable_modules/Fulma.2.16.0/Components/Modal.fs.js";
import { equals } from "../fable_modules/fable-library.3.7.12/Util.js";
import { Option as Option_5 } from "../fable_modules/Fulma.2.16.0/Elements/Form/Field.fs.js";
import { Option as Option_6, button } from "../fable_modules/Fulma.2.16.0/Elements/Button.fs.js";

export const CANVAS_ID = "tele-canvas";

export const MACRO_CANVAS_ID = "macro-canvas";

export function view(model, dispatch, extraCardButtons, extraNavbarButtons) {
    let children_13, children_15;
    let streamPathEl;
    const matchValue = map((r) => r.streamPath, model.anatomicalRegion);
    let pattern_matching_result, path_2;
    if (matchValue != null) {
        if (!isNullOrWhiteSpace(matchValue)) {
            pattern_matching_result = 0;
            path_2 = matchValue;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            let segments;
            const array = split(path_2, ["/"], null, 0);
            segments = array.filter((s) => (!isNullOrWhiteSpace(s)));
            const children_2 = toList(delay(() => map_1((seg) => react.createElement("div", {
                className: "historical-path-description-wrap",
            }, seg), segments)));
            streamPathEl = react.createElement("div", {
                className: "is-family-monospace",
            }, ...children_2);
            break;
        }
        case 1: {
            streamPathEl = "Unknown";
            break;
        }
    }
    return columns(singleton(new Option(8, "full-page-content")), ofArray([column(singleton(new Option_1(0, new Screen(0), new ISize(0))), toList(delay(() => append(singleton_1(card(singleton(new Common_GenericOption(0, "patient-search-card embed-card")), ofArray([header(empty(), singleton(Header_title(empty(), singleton("Patient Details")))), content(empty(), ofArray([FormField_labeledField("Patient", "Patient ID", defaultArg(map((session) => session.patientId, model.session), "Unknown"), []), FormField_labeledField("Session", "Session ID", defaultArg(map((session_1) => session_1.sessionId, model.session), "Unknown"), []), FormField_labeledField("Session", "Session Name", defaultArg(map((session_2) => session_2.sessionName, model.session), "Unknown"), []), FormField_labeledField("StreamPath", "Stream Path", streamPathEl, [])])), footer(empty(), toList(delay(() => extraCardButtons)))]))), delay(() => (model.layoutConfig.isInForm ? singleton_1(card(ofArray([new Common_GenericOption(0, "embed-card"), new Common_GenericOption(1, singleton(["style", {
        marginTop: "1em",
    }]))]), ofArray([react.createElement("div", {
        id: "webrtc-overlay-macro",
        className: "webrtc-overlay",
    }), react.createElement("canvas", {
        id: MACRO_CANVAS_ID,
    })]))) : empty_1())))))), column(singleton(new Option_1(4, ofArray([new Modifier_IModifier(22), new Modifier_IModifier(30, new FlexDirection_Option(2))]))), ofArray([navbar(singleton(new Option_2(7, "tele-nav")), ofArray([Start_div(ofArray([new Common_GenericOption(2, singleton(new Modifier_IModifier(36, new FlexGrow_Option(0)))), new Common_GenericOption(1, singleton(["style", {
        width: "25%",
    }]))]), singleton(Item_div(singleton(new Item_Option(7, singleton(new Modifier_IModifier(13)))), toList(delay(() => extraNavbarButtons))))), Item_div(singleton(new Item_Option(7, ofArray([new Modifier_IModifier(36, new FlexGrow_Option(1)), new Modifier_IModifier(32, new FlexJustifyContent_Option(2))]))), toList(delay(() => {
        let patternInput;
        const matchValue_1 = model.streamStatus;
        switch (matchValue_1.tag) {
            case 0: {
                patternInput = ["connecting", "Connecting..."];
                break;
            }
            case 1:
            case 2:
            case 5:
            case 3: {
                patternInput = ["paused", "Stream Paused"];
                break;
            }
            case 4: {
                patternInput = ["unpaused", "Live Capture"];
                break;
            }
            case 6: {
                patternInput = ["stopped", "Stream Ended"];
                break;
            }
            default: {
                patternInput = ["failed", "Error"];
            }
        }
        return singleton_1(label(ofArray([new Option_3(3, singleton(new HTMLAttr(99, "tele-nav-label"))), new Option_3(2, `tele-nav-label ${patternInput[0]}`)]), ofArray([react.createElement("img", {
            src: "info-light.svg",
        }), patternInput[1]])));
    }))), End_div(ofArray([new Common_GenericOption(2, singleton(new Modifier_IModifier(36, new FlexGrow_Option(0)))), new Common_GenericOption(1, singleton(["style", {
        width: "25%",
    }]))]), empty())])), (children_13 = toList(delay(() => {
        let children_8, matchValue_2;
        return append(singleton_1((children_8 = [label(singleton(new Option_3(2, "webrtc-overlay-label")), singleton((matchValue_2 = model.streamStatus, (matchValue_2.tag === 3) ? "Session in Progress - Waiting on Image Capture to Resume on Device" : ((matchValue_2.tag === 6) ? "This Stream Has Ended" : ((matchValue_2.tag === 5) ? "This Session Has Ended" : ((matchValue_2.tag === 0) ? "Connecting..." : ((matchValue_2.tag === 1) ? "Waiting on Session to Start..." : ((matchValue_2.tag === 4) ? "Capture Started - Waiting on Image" : ((matchValue_2.tag === 2) ? "Session in Progress - Waiting on Image Capture to Start on Device" : "An error has occured")))))))))], react.createElement("div", {
            id: "webrtc-overlay",
            className: "webrtc-overlay",
        }, ...children_8))), delay(() => append(singleton_1(react.createElement("canvas", {
            id: CANVAS_ID,
            className: "viewer",
        })), delay(() => {
            let props_14, props_15;
            const matchValue_3 = [model.signalingClient, model.peerConnection];
            let pattern_matching_result_1, peerConnection, signalingClient;
            if (matchValue_3[0] != null) {
                if (matchValue_3[1] != null) {
                    pattern_matching_result_1 = 0;
                    peerConnection = matchValue_3[1];
                    signalingClient = matchValue_3[0];
                }
                else {
                    pattern_matching_result_1 = 1;
                }
            }
            else {
                pattern_matching_result_1 = 1;
            }
            switch (pattern_matching_result_1) {
                case 0: {
                    return singleton_1((props_14 = ofArray([new ILiveTelepathologyProps(0, signalingClient), new ILiveTelepathologyProps(1, peerConnection), new ILiveTelepathologyProps(2, model.dataChannels), new ILiveTelepathologyProps(3, model.layoutConfig), new ILiveTelepathologyProps(4, [CANVAS_ID, MACRO_CANVAS_ID]), new ILiveTelepathologyProps(5, (msg) => {
                        dispatch(new TelepathologyMsg(15, msg));
                    }), new ILiveTelepathologyProps(6, (vctx) => {
                        dispatch(new TelepathologyMsg(9, vctx.currentFrame));
                    }), new ILiveTelepathologyProps(7, (arg_1) => {
                        iterate((arg) => {
                            dispatch(new TelepathologyMsg(10, arg));
                        }, toArray(ControlMessage_tryFromRaw_4A75406F(arg_1)));
                    }), new ILiveTelepathologyProps(8, false)]), (props_15 = keyValueList(props_14, 1), react.createElement(LiveTelepathology, props_15))));
                }
                case 1: {
                    return singleton_1(Helpers_nothing);
                }
            }
        }))));
    })), react.createElement("div", {
        className: "block webrtc-container",
    }, ...children_13)), (children_15 = [react.createElement("img", {
        src: "flag-light.svg",
    }), "Double click an image to flag it for review"], react.createElement("div", {
        className: "tele-nav-string",
    }, ...children_15))])), modal(singleton(new Option_4(1, model.sessionChangedModalActive)), ofArray([background(empty(), empty()), Card_card(empty(), ofArray([Card_head(empty(), singleton("The Session or Patient has Changed")), Card_body(empty(), singleton(columns(singleton(new Option(9, singleton(["style", {
        margin: "1em",
    }]))), ofArray([column(empty(), ofArray([react.createElement("h3", {}, "Previous Session:"), FormField_labeledField("Patient", "Patient ID", defaultArg(map((session_3) => session_3.patientId, model.previousSession), "Unknown"), toList(delay(() => ((!equals(map((s_13) => s_13.patientId, model.session), map((s_14) => s_14.patientId, model.previousSession))) ? singleton_1(new Option_5(10, "changed-previous")) : empty_1())))), FormField_labeledField("Session", "Session ID", defaultArg(map((session_4) => session_4.sessionId, model.previousSession), "Unknown"), toList(delay(() => ((!equals(map((s_16) => s_16.sessionId, model.session), map((s_17) => s_17.sessionId, model.previousSession))) ? singleton_1(new Option_5(10, "changed-previous")) : empty_1())))), FormField_labeledField("Session", "Session Name", defaultArg(map((session_5) => session_5.sessionName, model.previousSession), "Unknown"), toList(delay(() => ((!equals(map((s_19) => s_19.sessionName, model.session), map((s_20) => s_20.sessionName, model.previousSession))) ? singleton_1(new Option_5(10, "changed-previous")) : empty_1()))))])), column(empty(), ofArray([react.createElement("h3", {}, "New Session:"), FormField_labeledField("Patient", "Patient ID", defaultArg(map((session_6) => session_6.patientId, model.session), "Unknown"), toList(delay(() => ((!equals(map((s_23) => s_23.patientId, model.session), map((s_24) => s_24.patientId, model.previousSession))) ? singleton_1(new Option_5(10, "changed-new")) : empty_1())))), FormField_labeledField("Session", "Session ID", defaultArg(map((session_7) => session_7.sessionId, model.session), "Unknown"), toList(delay(() => ((!equals(map((s_26) => s_26.sessionId, model.session), map((s_27) => s_27.sessionId, model.previousSession))) ? singleton_1(new Option_5(10, "changed-new")) : empty_1())))), FormField_labeledField("Session", "Session Name", defaultArg(map((session_8) => session_8.sessionName, model.session), "Unknown"), toList(delay(() => ((!equals(map((s_29) => s_29.sessionName, model.session), map((s_30) => s_30.sessionName, model.previousSession))) ? singleton_1(new Option_5(10, "changed-new")) : empty_1()))))]))])))), Card_foot(empty(), singleton(button(ofArray([new Option_6(0, new Color_IColor(4)), new Option_6(18, (_arg1) => {
        dispatch(new TelepathologyMsg(22, false));
    })]), singleton("Acknowledge"))))]))]))]));
}

